import React, { useEffect, useState } from "react";

import { AreaPostcodeSearchStateProviderProps } from "./types";
import { Region } from "@hubcapp/types";
import { fireOnce } from "@ds-developer/frontend";
import { useTealium } from "@hubcapp/context";
import AreaPostcodeSearch from "./AreaPostcodeSearch";
import useQueryRegionLookup from "./hooks/useQueryRegionLookup";

const AreaPostcodeSearchStateProvider: React.FC<AreaPostcodeSearchStateProviderProps> = ({
  onChange,
  discard,
  propositionId,
  productCategoryId,
}) => {
  const [input, setInput] = useState<string>("<POSTCODE>");
  const { trackEvent } = useTealium();
  const regionLookup = useQueryRegionLookup(
    input,
    propositionId || "",
    productCategoryId || "",
  );

  useEffect(() => {
    setInput("<POSTCODE>");
  }, [discard]);

  const onRegionSelected = (value: Region | null) => {
    if (value && value.regionName) {
      onChange(value);
    }
  };

  const handleTextChange = (text: string) => {
    if (text === "") {
      setInput("<POSTCODE>");
      return;
    }
    setInput(text);
  };

  const handleOnInputClick = () => {
    fireOnce(
      "Areas & prices - Add Area|Interaction|Start Entering A Postcode",
      () => {
        trackEvent({
          eventCategory: "Areas & prices - Add Area",
          eventAction: "Interaction",
          eventLabel: "Start Entering A Postcode",
        });
      },
    );
  };

  return (
    <AreaPostcodeSearch
      onInputChange={(text: string) => handleTextChange(text)}
      areaData={regionLookup.data ? regionLookup.data.regionLookup : []}
      onRegionSelected={onRegionSelected}
      onInputClick={handleOnInputClick}
    />
  );
};

export default AreaPostcodeSearchStateProvider;
